import {changeEvent} from "../../../../../webpack/modules/events";
import {renderPreviewImage} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page .option-inline-selectable input[name="orientation"]', false, async function(element) {
    let container = element.closest('.product-scope');

    renderPreviewImage(container, false);
});